import { useCallback } from 'react';
import type { ConceptCardScope } from './store';
import { useConceptCardStore } from './store';

/**
 * Открытие карточки понятия в отборе страницы: страницы раздела показывают понятие
 * ровно в том отборе, в котором его увидели, и правило это общее для всех них.
 */
export const useOpenConceptCard = (scope: ConceptCardScope) => {
  const open = useConceptCardStore((store) => store.open);
  const { filters, dateFrom, dateTo } = scope;

  return useCallback(
    (conceptId: string) => open(conceptId, { filters, dateFrom, dateTo }),
    [open, filters, dateFrom, dateTo],
  );
};
